export default __webpack_public_path__ + "static/media/aca.so-galaxy.b50b0988.svg";